export class ComponentRepairData {
    public componentId: number;
    public cost: number;
    public date: Date;
    public comment: string;
    public smu:number;
    public downTimeHrs:number;
    public labourHrs:number;
    public labourCost:number;
    public parts:number;
    public misc:number;
    public planned:boolean = false;
    public equipmentId: number;
    public DateUTC: string;
}

export class CrackStausUpdateVM {
    public obsId: number;
    public status: boolean;
    public date: Date;
    public comment: string;
    public smu:number;
    public cost:number;
    public statusId: number;
}
export class CrackStatusesVM {
    public Id: number;
    public CrackStatus: string;
    public Active: boolean;
    public SortOrder: number;

}